import { render, staticRenderFns } from "./SuccessfulPostulation.vue?vue&type=template&id=38eaf69e&scoped=true"
import script from "./SuccessfulPostulation.vue?vue&type=script&lang=ts"
export * from "./SuccessfulPostulation.vue?vue&type=script&lang=ts"
import style0 from "./SuccessfulPostulation.vue?vue&type=style&index=0&id=38eaf69e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eaf69e",
  null
  
)

export default component.exports